import { render, staticRenderFns } from "./ShipmentScan.vue?vue&type=template&id=371cafc8&scoped=true&"
import script from "./ShipmentScan.vue?vue&type=script&lang=js&"
export * from "./ShipmentScan.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentScan.vue?vue&type=style&index=0&id=371cafc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371cafc8",
  null
  
)

export default component.exports